import quizData from '../data/quiz.json'

export default {
  state: {
    correctNumberOfQuestions: 0,
    currentQuestionNumber: 1,
    currentQuestionReviewNumber: 1,
    numbersOfQuestions: [10, 20, 30],
    questionPool: [],
    quizQuestions: [], // holds question for one quiz
    answeredQuestions: [], // holds all the question answered
    selectedNumberOfQuestions: 5,
    actualNumberOfQuestions: 0,
    selectedTopic: "all_topics",
    androidLink: "https://play.google.com/store/apps/details?id=io.chefy.brokernotes",
    iosLink: "https://itunes.apple.com/us/app/broker-notes/id1351101355?mt=8",
  },

  mutations: {
    addAnsweredQuestion(state, question) {
      state.answeredQuestions.push(question)
    },

    setActualNumberOfQuestions(state, actualNumberOfQuestions) {
      state.actualNumberOfQuestions = actualNumberOfQuestions
    },

    setAnsweredQuestions(state, questions) {
      state.answeredQuestions = questions
    },

    setCorrectNumberOfQuestions(state, correctNumberOfQuestions) {
      state.correctNumberOfQuestions = correctNumberOfQuestions
    },

    setCurrentQuestionNumber(state, currentQuestionNumber) {
      state.currentQuestionNumber = currentQuestionNumber
    },

    setNumberOfQuestions(state, numberOfQuestions) {
      state.selectedNumberOfQuestions = numberOfQuestions
    },

    setCurrentQuestionReviewNumber(state, currentQuestionReviewNumber) {
      state.currentQuestionReviewNumber = currentQuestionReviewNumber
    },

    setQuestionPool(state, questionsObject) {
      state.questionPool.push(questionsObject)
    },

    setQuizQuestions(state, questions) {
      state.quizQuestions = questions
    },

    setTopic(state, topic) {
      state.selectedTopic = topic
    }
  },

  actions: {
    resetState(context) {
      context.commit("setAnsweredQuestions", [])
      context.commit("setCorrectNumberOfQuestions", 0)
      context.commit("setCurrentQuestionNumber", 1)
      context.commit("setCurrentQuestionReviewNumber", 1)
      context.commit("setQuizQuestions", [])
    },

    initQuestionPool(context) {
      context.commit('setQuestionPool', quizData)
    },

    initQuizQuestions(context) {
      var { questionPool, quizQuestions, selectedNumberOfQuestions, selectedTopic }  = context.state
      var shuffledAllQuestions
      if (selectedTopic == "all_topics") {
        var allQuestions = []
        questionPool.forEach((questionsObject) => {
          allQuestions = allQuestions.concat(questionsObject.questions)
        })

        shuffledAllQuestions = allQuestions.sort(() => 0.5 - Math.random()) // shuffle
        quizQuestions = shuffledAllQuestions.slice(0, selectedNumberOfQuestions)
      } else {
        var selectedQuestionObject = questionPool.find((questionsObject) => {
          return selectedTopic === questionsObject.slug
        })

        shuffledAllQuestions = selectedQuestionObject.questions.sort(() => 0.5 - Math.random()) // shuffle
        quizQuestions = shuffledAllQuestions.slice(0, selectedNumberOfQuestions)
      }

      // shuffle options under each question
      quizQuestions.forEach((quizQuestion) => {
        var quizOptions = quizQuestion.options
        quizOptions.sort(() => { return 0.5 - Math.random()})

        quizQuestions.options = quizOptions
      })

      context.commit("setQuizQuestions", quizQuestions)
      context.commit("setActualNumberOfQuestions", quizQuestions.length)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/index.js